import { render } from "./VenuesView.vue?vue&type=template&id=0ceddfb6&scoped=true"
import script from "./VenuesView.vue?vue&type=script&lang=js"
export * from "./VenuesView.vue?vue&type=script&lang=js"

import "./VenuesView.vue?vue&type=style&index=0&id=0ceddfb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ceddfb6"]])

export default __exports__